module.exports = __webpack_public_path__ + "assets/img/img179.5d495744.png";